import { $ } from '@utils';
import lottie from 'lottie-web';

function init() {
  if (!$('[data-au-form-header-lottie]')) return;

  addEventListeners();
}

function addEventListeners() {
  const lottieContainer = $('[data-au-form-header-lottie]');
  const lottiePath = $('[data-au-form-header-lottie]').dataset.auFormHeaderLottie;

  lottie.loadAnimation({
    container: lottieContainer,
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path: lottiePath,
  });
}

export default { init };
